import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loyaltyService } from '../../services/loyaltyService';

export const useGetReservationLimits = () => {
  return useQuery({
    staleTime: 1000 * 60,
    queryKey: [QUERY_KEYS.loyalty.reservation_limits],
    queryFn: () =>
      loyaltyService.reservationLimits().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
